export default __webpack_public_path__ + "static/media/ekush.fd3a920e.jpg";